import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import { Bubble } from 'ctia-ui';
import ApproveButton from 'components/request/ApproveButton';
import ReqLink from 'components/RequestsLink';
import { getRequestTypeTitle, getStatusTitle } from 'helpers/RequestHelper';
import { fetchApproveWaitingRequests, clearRequests } from 'actions/requests';
import { startPreloader, finishPreloader } from 'actions/preloader';

class ApproveList extends Component {
  componentDidMount() {
    const {
      startPreloader,
      finishPreloader,
      fetchApproveWaitingRequests
    } = this.props;

    startPreloader()
      .then(fetchApproveWaitingRequests)
      .then(finishPreloader);
  }

  componentWillUnmount() {
    this.props.clearRequests();
  }

  renderRows() {
    return _.map(this.props.requests.list, req => {
      const type = getRequestTypeTitle(req.requesttypeid);
      const status = getStatusTitle(req.requeststatusid);
      return (
        <tr key={req.id}>
          <td>
            <ReqLink
              linkTitle={req.formatedtransactionnumber}
              requestId={req.id}
            />
          </td>
          <td>{req.name}</td>
          <td>{req.modelnumber}</td>
          <td>{req.display}</td>
          <td>{type}</td>
          <td>{status}</td>
          <td>
            <ApproveButton id={req.id} request={req} />
            <ApproveButton id={req.id} request={req} withdraw={true} />
          </td>
        </tr>
      );
    });
  }

  render() {
    const { requests } = this.props;

    if (_.isEmpty(requests)) return null;

    if (_.isEmpty(requests.list)) {
      return <Bubble type="success">No requests waiting for approval.</Bubble>;
    }

    return (
      <div>
        <Bubble>
          Below is a list of the requests that are complete and waiting for
          approval.
        </Bubble>
        <Table striped condensed hover>
          <thead>
            <tr>
              <th>Request Id</th>
              <th>Manufacturer</th>
              <th>Model Name / Number</th>
              <th>Device Type</th>
              <th>Request Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{this.renderRows()}</tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps({ requests }) {
  return { requests };
}

export default connect(
  mapStateToProps,
  {
    fetchApproveWaitingRequests,
    clearRequests,
    startPreloader,
    finishPreloader
  }
)(ApproveList);



// WEBPACK FOOTER //
// ./src/components/request/ApproveList.js